module.exports = __webpack_public_path__ + "static/media/IEEEP-1.9cb74d26.jpg";